import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { I3OneUIProvider } from '@i3one/react-ui'
import '@i3one/react-ui/style.css'
import themeObj from './I3Theme'
import { invokeCaptcha } from './components'
import { LayoutContextProvider } from './Context/LayoutContext'
import { ContextProvider } from './Context'
import { Layout } from './components/layout/layout'

function App() {
  const theme = createTheme(themeObj)
  ;(() => {
    invokeCaptcha('homePage')
  })()
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <I3OneUIProvider> */}
      <ContextProvider>
        <LayoutContextProvider>
          <Layout />
        </LayoutContextProvider>
      </ContextProvider>
      {/* </I3OneUIProvider> */}
    </ThemeProvider>
  )
}

export default App
